/* unplugin-vue-components disabled */import { render } from "./settings-icon.vue?vue&type=template&id=6a96a21c&scoped=true"
const script = {}

import "./settings-icon.vue?vue&type=style&index=0&id=6a96a21c&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a96a21c"],['__file',"src/pages/settings/superuser/settings-icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a96a21c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a96a21c', __exports__)) {
    api.reload('6a96a21c', __exports__)
  }
  
  module.hot.accept("./settings-icon.vue?vue&type=template&id=6a96a21c&scoped=true", () => {
    api.rerender('6a96a21c', render)
  })

}


export default __exports__